import { CNewsletterEmailStashKey } from '@/components/footer-navigation/consts';
import observerFill from '@/utils/observerFill/observerFill';

/**
 * Applies the newsletter email stored in a cookie to the email input field
 * of a form on the page. If the email exists in a cookie, it sets the value
 * of the input field. Finally, it removes the email from a cookie.
 */
export default async function applyNewsletterEmail(): Promise<void> {
    const email = await globalThis.dcUtils.cookies.getCookie(CNewsletterEmailStashKey);

    if (!email?.value) {
        return;
    }

    observerFill<HTMLInputElement>({
        field: 'value',
        selector: '.hbspt-form > form input[name="email"][type="email"]',
        timeout: 10_000,
        value: email.value,
    }).finally(() => globalThis.dcUtils.cookies.deleteCookie(CNewsletterEmailStashKey));
}
